import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { debounceTime, tap, switchMap, startWith, filter } from 'rxjs/operators';
import { ClientaddressesService } from 'src/app/services/apiclient/clientaddresses/clientaddresses.service';
import { CitiesService } from 'src/app/services/apiclient/cities/cities.service';
import { ClientaccountService } from 'src/app/services/apiclient/clientaccount/clientaccount.service';
import { Observable, forkJoin, fromEvent } from 'rxjs';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { CountriesService } from 'src/app/services/apiclient/countries/countries.service';
import { ValidatorsService } from 'src/app/services/validators/validators.service';
import { DeleteaddressComponent } from '../deleteaddress/deleteaddress.component';
import { TranslateService } from '@ngx-translate/core';
import {CssService} from "../../../../services/css-service";


@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css']
})
export class AddressComponent implements OnInit {

  @ViewChild('autoCompleteCountry', { read: MatAutocompleteTrigger, static: true }) acCountry: MatAutocompleteTrigger | any;


  @ViewChild('inputPostal') inputPostal: ElementRef | any;

  @ViewChild('selectCities') inputCities: MatSelect | any;

  // Address
  clientAddresses: any[] | any;
  selectedAddress: any;
  addressToUpdate: any;

  // Event resize
  eventHeight: Observable<any> = fromEvent(window, "resize");
  innerHeight: number = window.innerHeight;

  // Form data
  countries: any;
  postals: any;
  cities: any;
  addressForm: FormGroup | any;

  filteredCountries: Observable<any> | any;
  filteredPostals: Observable<any> | any;
  filteredCities: Observable<any> | any;

  loaders: any = {
    countries: false,
    postals: false,
    cities: false,
    page: true
  }

  unavailablePostal: boolean = false;

  errorMessage: string | any;

  // Client
  client: any;

  flagDefault: boolean = false;

  type: string | any;

  /**
   * Composant actuellement selectionné (selection ou creation)
   */
  currComp: string = "select";

  cometoaccount: boolean = false;

  autoCompleteCountryVal = false;
  // Pays séléctionné
  selectedCountry: any;
  selectedAddressdefaultchanged = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<AddressComponent>,
    private formBuilder: FormBuilder,
    private apiAddress: ClientaddressesService,
    private cityApi: CitiesService,
    private countriesApi: CountriesService,
    private clientAccApi: ClientaccountService,
    private tools: ToolsService,
    private vs: ValidatorsService,
    public cssService: CssService,
    private dialog: MatDialog,
    public translate: TranslateService
  ) {
    if (data) {

      this.selectedAddress = data.address;
      this.clientAddresses = data.clientAddresses;

      this.type = data.type;
      this.cometoaccount = data.cometoaccount ? true : false;
    }
  }

  ngOnInit() {


    this.onWindowResize();
    this.createForm();

    forkJoin(
      this.countriesApi.getCountries(),
      this.clientAccApi.getClientAccount()
    ).subscribe(([countries, client]) => {

      this.countries = countries;

      this.client = client;

      this.getCountriesOnChange();
      this.getPostalsOnChange();
      this.setDefaultCountry();

      this.addressToUpdate ? this.initFormdata() : this.initCompletName();



    });

  }

  onKeypressEvent(event: any) {

  }

  /**
   * @description Set le pays par défaut
   * @returns {void}
   */
  setDefaultCountry(): void {
    const pos = this.tools.getStor("point_of_sale");
    const countryId = pos ? pos.country.id : this.countries[0].id;
    const countryName = pos ? pos.country.name : this.countries[0].name;
    this.addressForm.get("country_name").setValue(countryName, { emitEvent: false });
    this.addressForm.get("id_country").setValue(countryId, { emitEvent: false });
  }

  /**
   * @description Créer le formulaire d'adresse
   */
  createForm(): void {

    this.addressForm = this.formBuilder.group({
      name: ['', [Validators.required, this.vs.noSpaceValidator]],

      address: ['', [Validators.required, this.vs.noSpaceValidator]],
      professional: [0],
      company_identification: [''],
      activity_identification: [''],
      tax_identification: [''],
      postal: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
      city_name: [{ value: '', disabled: true }, [Validators.required]],
      country_name: ['', [Validators.required]],
      comment: '',
      is_default: '',
      id_country: '',
      id_city: '',
      address_id: ''
    });
  }

  /**
   * @description Supprime toutes les données du formulaire d'adresse
   */
  removeForm(): void {
    this.addressForm.get('name').setValue(null);
    this.addressForm.get('address').setValue(null);
    this.addressForm.get('postal').setValue(null);
    this.addressForm.get('city_name').setValue(null);
    this.addressForm.get('professional').setValue(0);
    this.addressForm.get('company_identification').setValue(null);
    this.addressForm.get('activity_identification').setValue(null);
    this.addressForm.get('tax_identification').setValue(null);
    this.addressForm.get('is_default').setValue(null);
    this.addressForm.get('comment').setValue(null);
    this.addressForm.get('address_id').setValue(null);
  }


  /**
   * @description Incremente par defaut le champ name avec le nom + prénom du client
   * @return {void}
   */
  initCompletName(): void {

    this.addressForm.get('name').setValue(this.client.lastname + " " + this.client.firstname, { emitEvent: false });
    this.loaders.page = false;
  }

  /**
 * @description Incremente tous les champs du formulaire avec les infos de l'adresse à modifier
 * @return {void}
 */
  initFormdata(): void {


    forkJoin(
      this.cityApi.getCities(this.addressToUpdate.id_country, this.addressToUpdate.postal),
      this.cityApi.getPostals(this.addressToUpdate.id_country, this.addressToUpdate.postal)
    ).subscribe(([cities, postals]) => {

      this.filteredCountries = this.filterCountries(this.addressToUpdate.country_name);



      this.filteredCities = cities;


      setTimeout(() => {
        this.filteredPostals = postals;
      }, 200);

      this.addressForm.get('name').setValue(this.addressToUpdate.name, { emitEvent: false });
      this.addressForm.get('address').setValue(this.addressToUpdate.address, { emitEvent: false });
      this.addressForm.get('postal').setValue(this.addressToUpdate.postal, { emitEvent: false });
      this.addressForm.get('city_name').setValue(this.addressToUpdate.city_name, { emitEvent: false });
      this.addressForm.get('professional').setValue(parseInt(this.addressToUpdate.professional));
      this.addressForm.get('company_identification').setValue(this.addressToUpdate.company_identification, { emitEvent: false });
      this.addressForm.get('activity_identification').setValue(this.addressToUpdate.activity_identification, { emitEvent: false });
      this.addressForm.get('tax_identification').setValue(this.addressToUpdate.tax_identification, { emitEvent: false });
      this.addressForm.get('id_city').setValue(this.addressToUpdate.id_city, { emitEvent: false });
      this.addressForm.get('country_name').setValue(this.addressToUpdate.country_name, { emitEvent: false });
      this.addressForm.get('id_country').setValue(this.addressToUpdate.id_country, { emitEvent: false });
      this.addressForm.get('is_default').setValue(this.addressToUpdate.is_default, { emitEvent: false });
      this.addressForm.get('comment').setValue(this.addressToUpdate.comment, { emitEvent: false });
      this.addressForm.get('address_id').setValue(this.addressToUpdate.address_id, { emitEvent: false });



      if (this.addressToUpdate.is_default > 0) { this.flagDefault = true; }

      this.setValidators();
      this.loaders.page = false;

    });

  }

  isFieldrequired(field: string): boolean | any {
    const thisField = this.addressForm.controls[field];
    if (thisField.errors && thisField.touched) {
      if (thisField.errors.required) {
        return true;
      }
    }
  }

  addorUpdateAddress(): void {
    const formVal = this.addressForm.value;

    this.addressForm.get('city_name');


    // this.dialogRef.disableClose = true;
    this.loaders.page = true;
    formVal.is_default ? formVal.is_default = 1 : formVal.is_default = 0;

    //on reset l'ancienne valeur par default
    if (this.addressToUpdate && formVal.is_default == 1) {
      this.resetOldDefaultAddress();
    }


    this.addressToUpdate ? this.updateAddress(formVal) : this.creatAddress(formVal);
  }

  /**
   * @description Sélectionne une adresse
   * @param {any} address
   * @returns {void}
   */
  selectAddress(address: any): void {


    if (this.cometoaccount) {
      this.setDefaultAddress(address);
    }

    this.selectedAddress = address;
  }

  creatAddress(formVal: any): void {

    this.errorMessage = "";

    this.apiAddress.createAddress(formVal, this.type).subscribe(

      data => {

        if (data.code === 0) {

          //
          this.changeComp("select");

          this.tools.openSnackBar(this.translate.instant('Addrcreated'), "great");
          this.clientAddresses = data.addresses;
          this.setAdressfirst();

          this.apiAddress.setAddresses(data.addresses);
          this.loaders.page = false;

        } else {

           //traduction
           if (data.code == -10) {
            let regex = /\[(.*?)\]/g;
            let found = data.message.match(regex);
            if (found) {
              data.message = this.translate.instant("php.paramrequired", { found })
            }

          }


          this.errorMessage = data.message;
          this.loaders.page = false;
        }


      }

    )
  }

  updateAddress(formVal: any): void {

    this.errorMessage = "";
    this.apiAddress.updateAddress(formVal, this.type).subscribe(


      data => {

        if (data.code === 0) {


          this.clientAddresses = data.addresses;

          this.apiAddress.setAddresses(data.addresses);

          this.tools.openSnackBar(this.translate.instant('Addrchanged'), "great");


          if (this.selectedAddress && this.selectedAddress.address_id === formVal.address_id) {
            this.selectedAddress = data.updated_address;
          }

          this.changeComp("select");

        } else {

          //traduction
          if (data.code == -10) {
            let regex = /\[(.*?)\]/g;
            let found = data.message.match(regex);
            if (found) {
              data.message = this.translate.instant("php.paramrequired", { found })
            }

          }

          this.errorMessage = data.message;
          this.loaders.page = false;
          setTimeout(() => {
            this.errorMessage = "";
          }, 4000);

        }

        this.loaders.page = false;

      }

    )
  }


  setProfessional(value: any) {
    this.addressForm.get('professional').setValue(value);
    this.setValidators();
  }

  setValidators() {
    const professionalInput = this.addressForm.get("professional");
    if (professionalInput.value === 0) {
      professionalInput.setValidators([Validators.required]);
      professionalInput.setValidators([Validators.required]);
    } else {
      professionalInput.setValidators(null);
      professionalInput.setValidators(null);
    }

    if (this.addressForm.get("city_name")) {
      this.addressForm.get("city_name").enable();
    }
  }

  //optionSelected
  optionSelected($ev: any) {
    this.autoCompleteCountryVal = false;


  }



  /**
    * @description Incrémente la variable selectedCountry avec un object country
    * @param {Country} country
    * @return {Void}
    */
  setSelectedCountry(country: any): void {

    this.addressForm.get("country_name").setValue(country.name, { emitEvent: false });
    this.addressForm.get("id_country").setValue(country.id, { emitEvent: false });

    //reset postal and city
    this.removePostal();
    //focus
    this.inputPostal.nativeElement.focus();


  }


  // OnSelectOption (AutoComplete)

  onSelectCountry(country: any): void {

    this.addressForm.get("country_name").setValue(country.name, { emitEvent: false });
    this.addressForm.get("id_country").setValue(country.id, { emitEvent: false });
    this.removePostal();
    // this.acCountry.closePanel();
    this.inputPostal.nativeElement.focus();
  }

  onSelectPostal(postal: any): void {
    this.addressForm.get("postal").setValue(postal, { emitEvent: false });
    this.removeCity();
    this.loaders.cities = true;


    this.cityApi.getCities(this.addressForm.get("id_country").value, postal).then(cities => {

      this.addressForm.get("city_name").enable();
      if (cities.length > 0) {

        this.filteredCities = cities;


        if (cities.length === 1) {
          this.addressForm.get("city_name").setValue(cities[0].name);
          this.addressForm.get("id_city").setValue(cities[0].id);
        }

        setTimeout(() => {
          this.inputCities.focus();
          if (cities.length > 1) { this.inputCities.toggle(); }
        });

      }

      this.loaders.cities = false;

    });

  }

  onSelectCity(event: any, city: any) {

    if (event.isUserInput) {
      this.addressForm.get("id_city").setValue(city.id);
    }



  }

  // OnValueInputchange (AutoComplete)

  getCountriesOnChange(): void {


    this.addressForm.get("country_name").valueChanges
      .pipe(
        startWith(''),
        tap(() => {
          this.loaders.countries = true;
        })
      ).subscribe((value: any) => {


        const filteredValueResults = this.filterCountries(value);



        if (value || (this.type == 'delivry' && this.currComp == 'create')) {

          this.filteredCountries = (filteredValueResults.length > 0) ? filteredValueResults : null;

        } else {
          this.filteredCountries = this.countries.slice();

        }

        this.loaders.countries = false;

      });
  }

  getPostalsOnChange(): void {
    const countriesInput = this.addressForm.get("id_country");

    this.addressForm.get("postal").valueChanges
      .pipe(
        filter((v: any) => v && v.length > 3),
        debounceTime(200),
        tap(() => {
          this.loaders.postals = true;
        }),
        switchMap((value: any) => this.cityApi.getPostals(countriesInput.value, value))
      )
      .subscribe((postals: any) => {

        this.filteredPostals = (postals.length > 0) ? postals : null;

        if (this.filteredPostals) {

          this.onSelectPostal(this.filteredPostals[0]);
          this.unavailablePostal = false;

        } else {

          this.unavailablePostal = true;
          this.removeCity();

        }

        this.loaders.postals = false;

      });

  }


  countriesEligibleDelivivry() {

    this.filteredCountries = this.tools.getStor("countriesEligible") ? this.countries.filter((f: any) => this.tools.getStor("countriesEligible").some((item: any) => item.id_country === f.id)) : this.countries;

    return this.filteredCountries;

  }

  // Filters (AutoComplete)
  filterCountries(value: any): any {


    if (this.addressToUpdate) {

      const filterValue = value.toLowerCase();
      return this.countries.filter((country: any) => country.name.toLowerCase().indexOf(filterValue) === 0)
    };


    if (this.type == 'delivry') {
      return this.countriesEligibleDelivivry();

    } else {
      return this.countries;
    }

  }

  onTabKey() {
    if (this.filteredPostals) {
      this.addressForm.get('postal').setValue(this.filteredPostals[0]);
      this.onSelectPostal(this.filteredPostals[0]);
    }
  }

  onWindowResize() {
    this.eventHeight.subscribe(event => {
      this.innerHeight = event.currentTarget.innerHeight;
    });
  }

  removePostal() {

    this.filteredPostals = null;
    this.addressForm.get("postal").reset();
    this.addressForm.get("postal").setValue("");
    this.addressForm.get("city_name").disable();
    this.removeCity();
  }

  removeCity() {
    this.filteredCities = null;
    this.addressForm.get("id_city").reset();
    this.addressForm.get("city_name").reset();
    this.addressForm.get("id_city").setValue("");
    this.addressForm.get("city_name").setValue("");
  }


  /**
    * @description reset l'ancienne l'adresse par défaut
    * @param {any} add
    */
  resetOldDefaultAddress(): void {
    let old = this.clientAddresses.find((value: any) => value.is_default == 1);

    if (old) {
      old.is_default = 0;
      this.update(old);
      this.selectedAddressdefaultchanged = true;

      this.tools.openSnackBar(this.translate.instant('defaultAddrModify'), "great");

    }


  }



  /**
   * @description Définit l'adresse par défaut
   * @param {any} add
   */
  setDefaultAddress(add: any): void {

    this.clientAddresses.map((address: any) => {
          address.is_default = address.address_id !== add.address_id ? 0 : 1;
    })


    //select et favori pour le compte
    if (this.cometoaccount) { this.selectedAddress = add; }

    else {


      //on update le nouveau favori
      this.update(add);
      this.selectedAddressdefaultchanged = true;
      this.tools.openSnackBar(this.translate.instant('defaultAddrModify'), "great");


    }

  }

  /**
   * @description Ferme l a dialog en passant l'adresse selectionnée ou non
   * @params {boolean} passAddress
   */
  closeDial(passAddress?: boolean): void {


    passAddress ? this.update() : this.dialogRef.close();


  }
  /**
   * @description update l'adresse
   */
  update(add?: any) {

    this.errorMessage = "";
    this.loaders.page = true;

    let address = add ? add : this.selectedAddress;
    this.apiAddress.updateAddress(address, this.type).subscribe(


      data => {

        if (data.code === 0) {
          if (!add) {
            this.dialogRef.close({ address: this.selectedAddress });
          }

        } else {

          this.errorMessage = data.message;
          this.loaders.page = false;

          setTimeout(() => {
            this.errorMessage = "";
          }, 4000);

        }

        this.loaders.page = false;

      }

    )
  }

  /**
   * @description Gère le changement de composant
   */
  changeComp(newComp: string, add?: any): void {

    if (newComp === "update") {
      this.addressToUpdate = add;
      this.initFormdata();
    }
    if (newComp === "select") {
      this.removeForm();
      this.initCompletName();
      this.addressToUpdate = null;
    }


    if (newComp === "create" && this.type == 'delivry') {
      this.filterCountries(newComp);
    }


    this.currComp = newComp;

  }

  /**
   * @description Ouvre la dialog de suppression d'adresse
   * @param {number} addressId
   * @returns {void}
   */
  openDialDeletAddress(addressId: any): void {

    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      addressId: addressId,
      from: this.type,
    };

    const myDial = this.dialog.open(DeleteaddressComponent, myConf);

    myDial.afterClosed().subscribe((addresses) => {
      if (addresses) {
        setTimeout(() => {
          this.clientAddresses = addresses;
          this.setAdressfirst();

          this.apiAddress.setAddresses(addresses);
          if (this.selectedAddress.address_id === addressId) {
            this.selectedAddress = null;
          }
        });

      }
    });
  }

  blurEvent(event: any) {
    this.autoCompleteCountryVal = false;
  }

  focusEvent(event: any) {
    this.autoCompleteCountryVal = true;

  }

  setAdressfirst() {
    if (this.clientAddresses && this.clientAddresses.length == 1) {
      this.selectAddress(this.clientAddresses[0])
    }
  }
}
